export default __webpack_public_path__ + "static/media/card5.e5d26881.jpg";